<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Dashboard</span>
</mat-toolbar>

<br />
<div class="contenedorSpinner" *ngIf="isLoadingResults">
  <div class="loading-indicator">
    <mat-spinner></mat-spinner>
  </div>
</div>

<div
  *ngIf="!isLoadingResults"
  class="stats-cards apearAnimation grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-4"
>
  <div>
    <mat-card
      class="dashCard"
      [ngClass]="{ alertaFecha: dataDash.diasRestantesServicio < 10 }"
      style="color: white; background-color: #db2525"
    >
      <div style="text-align: center">
        <span class="font-normal">Fecha limite servicio</span> <small>(dd-mm-aaaa)</small>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >timer</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: large">
            {{ dataDash.fechaServicioHasta | date : "dd-MM-yyyy" }}
          </label>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <mat-card class="dashCard clickableCard">
      <div style="text-align: center">
        <span class="font-normal">Deportistas activos</span>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >hardware</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: x-large">
            {{ dataDash.deportistasActivos }}
          </label>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <mat-card class="dashCard clickableCard">
      <div style="text-align: center">
        <span class="font-normal">Deportistas que ingresaron al mes</span>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >today</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: x-large">
            {{ dataDash.deportistasIngresdoMes }}
          </label>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <mat-card class="dashCard clickableCard">
      <div style="text-align: center">
        <span class="font-normal">Ingresos hoy</span>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >event_available</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: x-large">
            {{ dataDash.ingresosHoy }}
          </label>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <mat-card class="dashCard">
      <div style="text-align: center">
        <span class="font-normal">Saldo</span>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >point_of_sale</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: x-large">
            {{ dataDash.saldo | currency : "" : "symbol" : "1.0-0" }}
          </label>
        </div>
      </div>
    </mat-card>
  </div>
  <div>
    <mat-card class="dashCard">
      <div style="text-align: center">
        <span class="font-normal">Ordenes de compra pendientes</span>
      </div>
      <div class="flex flex-row" style="text-align: center">
        <div class="basis-1/2">
          <mat-icon aria-hidden="false" style="font-size: x-large"
            >savings</mat-icon
          >
        </div>
        <div
          class="basis-1/2"
          style="display: flex; justify-content: center; align-items: center"
        >
          <label style="font-size: x-large">
            {{ dataDash.ordenesCompraPendientes }} </label
          ><!--   en estado creadas, significa que no se han presentado -->
        </div>
      </div>
    </mat-card>
  </div>
</div>

<br />

<mat-divider></mat-divider>

<app-puntos-grafica
  *ngIf="datosGrafica"
  [dataGrafica]="datosGrafica"
></app-puntos-grafica>
